/**
* 风控的设备详情 Android
*/
<template>
	<div style="display: flex;flex-direction: column; height: 100vh; margin: 0px 20px;">

		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>


		<div style="margin:20px 0px;">

			<el-alert v-show="successfulOperation" title="操作成功" type="success" :description="message" center show-icon>
			</el-alert>

			<el-alert v-show="operationFailed" title="操作失败" type="error" :description="message" center show-icon>
			</el-alert>

		</div>

		<el-row type="flex" justify="center ">
			<span style="width: 2%;" />
			<el-button style="width: 30%;" type="warning" @click="banAccount()">{{ text02 }}</el-button>
			<span style="width: 3%;" />
			<el-button style="width: 30%;" type="danger" @click="addBlacklist()">{{ text01 }}</el-button>
			<span style="width: 3%;" />
			<el-button style="width: 30%;" type="danger" @click="addBlackIp()">{{ text03 }}</el-button>
			<span style="width: 2%;" />
		</el-row>

		<el-descriptions :column="4" border style="padding-bottom: 60px; margin-top: 20px;">
			
			<el-descriptions-item label="应用广告ID">{{ handleEmptyDeviceDetail(data.aaid)}}</el-descriptions-item>

			<el-descriptions-item label="app版本号">
				<el-tag size="small">{{handleEmptyDeviceDetail(data.appVersion)}}</el-tag>
			</el-descriptions-item>

			<el-descriptions-item label="当前电量信息">{{ handleEmptyDeviceDetail(data.batteryLevel) }}</el-descriptions-item>

			<el-descriptions-item label="设备启动次数">{{ handleEmptyDeviceDetail(data.bootCount) }}</el-descriptions-item>

			<el-descriptions-item label="运营商">{{ handleEmptyDeviceDetail(data.carrierName) }}</el-descriptions-item>

			<el-descriptions-item label="充电状态">{{ handleEmptyDeviceDetail(data.chargeState) }}</el-descriptions-item>


			<el-descriptions-item label="adb是否开启">{{ data.checkAdb === 1 ? '是' : '否' }}</el-descriptions-item>

			<el-descriptions-item label="设备cpu信息">{{ handleEmptyDeviceDetail(data.cpuInfo) }}</el-descriptions-item>

			<el-descriptions-item label="创建时间">{{ handleEmptyDeviceDetail(data.createTime) }}</el-descriptions-item>

			<el-descriptions-item label="硬件设备类型">
				{{
			        data.deviceType === 1 ? '手机' :
			        data.deviceType === 2 ? '桌面' :
			        data.deviceType === 3 ? '汽车' :
			        data.deviceType === 4 ? '电视' :
			        data.deviceType === 6 ? '手表' :
					data.deviceType === 7 ? '未知设备' :
			        ''
			      }}
			</el-descriptions-item>

			<el-descriptions-item
				label="第一次安装时间">{{ handleEmptyDeviceDetail(data.firstSetupTime) }}</el-descriptions-item>

			<el-descriptions-item label="是否存在sim卡">{{data.hasSim === -1 ? '无' : '有' }}</el-descriptions-item>

			<el-descriptions-item label="id">{{ handleEmptyDeviceDetail(data.id) }}</el-descriptions-item>

			<el-descriptions-item label="是否是虚拟摄像头">{{data.isFakeCam === 0 ? '不是' : '有' }}</el-descriptions-item>

			<el-descriptions-item label="投屏状态判断">{{data.isShareScreen === 0 ? '不是' : '有' }}</el-descriptions-item>

			<el-descriptions-item label="设备语言设置">{{ handleEmptyDeviceDetail(data.language) }}</el-descriptions-item>

			<el-descriptions-item label="手机总锁屏时间">{{ handleEmptyDeviceDetail(data.lockTime) }}</el-descriptions-item>

			<el-descriptions-item label="是否开启mac随机化">
				{{
			        data.macRandom === 0 ? '未随机化' :
			        data.macRandom === 1 ? '随机化' :
			        data.macRandom === 2 ? '未知' :
					data.macRandom === 3 ? 'mac地址存在错误' :
			        ''
			      }}
			</el-descriptions-item>

			<el-descriptions-item label="设备总内存大小">{{ handleEmptyDeviceDetail(data.memTotal) }}</el-descriptions-item>

			<el-descriptions-item label="型号">{{ handleEmptyDeviceDetail(data.model) }}</el-descriptions-item>

			<el-descriptions-item label="网络连接类型">
				{{
			        data.networkType === 1 ? 'wifi' :
			        data.networkType === 2 ? '2g' :
			        data.networkType === 3 ? '3g' :
					data.networkType === 4 ? '4g' :
					data.networkType === 5 ? '5g' :
			        ''
			      }}
			</el-descriptions-item>

			<el-descriptions-item label="设备广告ID">{{ handleEmptyDeviceDetail(data.oaid) }}</el-descriptions-item>

			<el-descriptions-item label="Android版本">{{ handleEmptyDeviceDetail(data.osVersion) }}</el-descriptions-item>

			<el-descriptions-item label="手机品牌">{{ handleEmptyDeviceDetail(data.phoneBrand) }}</el-descriptions-item>

			<el-descriptions-item
				label="设备厂商信息">{{ handleEmptyDeviceDetail(data.productManufacturer) }}</el-descriptions-item>

			<el-descriptions-item label="设备系统名称">{{ handleEmptyDeviceDetail(data.productOs) }}</el-descriptions-item>

			<el-descriptions-item label="设备ROM信息">{{ handleEmptyDeviceDetail(data.rom) }}</el-descriptions-item>


			<el-descriptions-item label="屏幕亮度">{{ handleEmptyDeviceDetail(data.screenBright) }}</el-descriptions-item>

			<el-descriptions-item label="屏幕信息">{{ handleEmptyDeviceDetail(data.screenInfo) }}</el-descriptions-item>

			<el-descriptions-item label="设备sd卡总内存大小">{{ handleEmptyDeviceDetail(data.sdTotal) }}</el-descriptions-item>

			<el-descriptions-item label="请求id">{{ handleEmptyDeviceDetail(data.sequenceId) }}</el-descriptions-item>

			<el-descriptions-item
				label="运营商设备标识，需开通功能后方可获取">{{ handleEmptyDeviceDetail(data.uaid) }}</el-descriptions-item>

			<el-descriptions-item label="手机已启动时间">{{ handleEmptyDeviceDetail(data.upTime) }}</el-descriptions-item>

			<el-descriptions-item label="设备当前地区设置">{{ handleEmptyDeviceDetail(data.userRegion) }}</el-descriptions-item>


		</el-descriptions>

	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				sequenceId: '', //信息序号
				deviceId: '', //设备ID
				userId: '', //用户ID
				country: '', //国码
				id: '', //记录的ID
				phoneNumber: '', //手机号
				ip: '', //IP
				data: '', //接口返回的数据
				message: "", //提示的内容
				successfulOperation: false, //操作成功
				operationFailed: false, //操作失败
				deviceBaned: 0, // 该设备是否已被封禁 0-正常 1-已被封禁
				accountBaned: 0, //账号是否已被封禁  -3-用户已操作注销， 0-正常， 1-被禁言， 2-封号(未解绑设备) ，4-封号(已解绑设备) 
				ipBanded: 0, //0正常 1被封
				text01: "", //设备被封文本
				text02: "", //账号被封文本
				text03: "", //封禁IP
				//...
			};
		},
		mounted() {
			this.sequenceId = this.$route.query.sequenceId;
			this.deviceId = this.$route.query.deviceId;
			this.userId = this.$route.query.userId;
			this.country = this.$route.query.country;
			this.id = this.$route.query.id;
			this.phoneNumber = this.$route.query.phoneNumber;
			this.ip = this.$route.query.ip;

			console.log('sequenceId:', this.sequenceId);
			console.log('userId:', this.userId);
			console.log('country:', this.country);
			console.log('id:', this.id);
			console.log('phoneNumber:', this.phoneNumber);
			console.log('ip:', this.ip);

			this.fetchData();
		},
		methods: {
			fetchData() { //用户详情
				this.loadingData = true;

				const requestData = {}; //传递的参数
				requestData.sequenceId = this.sequenceId;
				requestData.userId = this.userId;

				axios.post(this.$p_url + '/admin/getDeviceAndroidInfoDetails', requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("后台数据返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.data = response.data.data.deviceAndroidInfo;
							this.deviceBaned = response.data.data.deviceBaned;
							this.accountBaned = response.data.data.accountBaned;
							this.ipBanded = response.data.data.ipBanded;

							switch (this.deviceBaned) { //该设备是否已被封禁
								case 0: //正常
									this.text01 = "封禁设备";
									break
								case 1: //已被封禁
									this.text01 = "该设备已经被封";
									break
							}

							switch (this.accountBaned) { //账号是否已被封禁
								case -3: //用户已操作注销
									this.text02 = "用户已操作注销";
									break
								case 0: //正常
									this.text02 = "封禁账号";
									break
								case 1: //被禁言
									this.text02 = "该账号被禁言";
									break
								case 2: //封号(未解绑设备)
									this.text02 = "被封号(未解绑设备)";
									break
								case 4: //封号(已解绑设备)
									this.text02 = "已封号(已解绑设备)";
									break
							}

							switch (this.ipBanded) { //IP是否已被封禁
								case 0: //正常
									this.text03 = "封禁IP";
									break
								case 1: //已被封禁
									this.text03 = "IP被封";
									break
							}


						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
					});
			},
			banAccount() { //封禁账号
				if (this.accountBaned == 0) {
					this.loadingData = true;
					axios.get(this.$p_url + '/admin/black/' + this.userId, {
							withCredentials: true, // 允许跨域携带 cookie
							headers: {
								'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
						.then(response => {
							this.loadingData = false;
							console.log("封禁账号 返回的值：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								this.message = "封禁账号成功!";
								this.successfulOperation = true;
								this.fetchData();
							} else { // 处理状态为失败的情况
								this.message = response.data.message;
								this.operationFailed = true;
							}
						})
						.catch(error => { // 请求失败时处理错误
							this.loadingData = false;
							alert("请求失败：" + error);
						});
				}
			},
			addBlacklist() { //封禁设备
				if (this.deviceBaned == 0) {
					this.loadingData = true;

					const requestData = {}; //传递的参数
					requestData.country = this.country;
					requestData.deviceId = this.deviceId
					requestData.id = this.id
					requestData.phoneNumber = this.phoneNumber;
					requestData.userId = this.userId;

					axios.post(this.$p_url + '/admin/forbidden/deviceId', requestData, {
							withCredentials: true, // 允许跨域携带 cookie
							headers: {
								'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
						.then(response => {
							this.loadingData = false;
							console.log("后台数据返回：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								this.message = "封禁设备成功!";
								this.successfulOperation = true;
								this.fetchData();
							} else {
								this.message = response.data.message;
								this.operationFailed = true;
							}
						})
						.catch(error => { // 请求失败时处理错误
							this.loadingData = false;
							alert('请求失败:' + error);
						});
				}
			},
			addBlackIp() { //封禁IP
				if (this.ipBanded == 0) {
					this.loadingData = true;

					const requestData = {};
					requestData.ip = this.ip;
					requestData.country = this.country;
					requestData.deviceId = this.deviceId
					requestData.id = this.id
					requestData.phoneNumber = this.phoneNumber;
					requestData.userId = this.userId;

					axios.post(this.$p_url + '/admin/forbidden/ip', requestData, {
							withCredentials: true,
							headers: {
								'Content-Type': 'application/json',
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
						.then(response => {
							this.loadingData = false;
							console.log("封禁IP：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								this.message = "封禁IP成功!";
								this.successfulOperation = true;
								this.fetchData();
							} else {
								this.message = response.data.message;
								this.operationFailed = true;
							}
						})
						.catch(error => { // 请求失败时处理错误
							this.loadingData = false;
							alert('请求失败:' + error);
						});
				}
			},
			handleEmptyDeviceDetail(value) {
				return value ? value : '-'; // 如果值为空，则返回占位符 '-'
			}
			//...
		},

		//....
	}
</script>

<style>
</style>